// Set ISO languages
// Source : http://www.lingoes.net/en/translator/langcode.htm
export const availableLanguages = [ 'fr', 'en' ]
export const en = [ 'en', 'en-AU', 'en-BZ', 'en-CA', 'en-CB', 'en-GB', 'en-IE', 'en-JM', 'en-NZ', 'en-PH', 'en-TT', 'en-US', 'en-ZA', 'en-ZW' ]
export const fr = [ 'fr', 'fr-BE', 'fr-CA', 'fr-CH', 'fr-FR', 'fr-LU', 'fr-MC' ]
export const frISO = 'fr-FR'
export const enISO = 'en-GB'
export const defaultLanguage = 'fr'
